import { render } from "./MotivationActivite.vue?vue&type=template&id=b0ccb264&scoped=true"
import script from "./MotivationActivite.vue?vue&type=script&lang=js"
export * from "./MotivationActivite.vue?vue&type=script&lang=js"

import "./MotivationActivite.vue?vue&type=style&index=0&id=b0ccb264&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0ccb264"]])

export default __exports__